import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./utils/AuthContext";
import Landing from "./pages/Landing/Landing";
import Confirm from "./pages/Confirm/Confirm";
import Download from "./pages/Download/Download";
import Recovery from "./pages/Recovery/Recovery";
import NotFound from "./pages/NotFound/NotFound";
import SignUp from "./pages/Auth/SignUp";
import LogIn from "./pages/Auth/LogIn";
import OakApp from "./oakApp/oakApp";
import PrivateRoutes from "./utils/PrivateRoutes";
import Account from "./pages/Profile/Profile";
import Verification from "./pages/Verification/Verification";
import Setup from "./pages/Setup/Setup";
import Blog from "./pages/Blog/Blog";
import Policy from "./pages/Policy/Policy";
import ConfirmPayment from "./pages/Confirm/ConfirmPayment";

export default function App() {
    return (
        <div className="app">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/download" element={<Download />} />
                        <Route path="/confirm" element={<Confirm />} />
                        <Route path="/success" element={<ConfirmPayment />} />
                        <Route path="/recovery" element={<Recovery />} />
                        <Route path="/signup" element={<SignUp />} />
                        <Route path="/login" element={<LogIn />} />
                        <Route path="/verify" element={<Verification />} />
                        <Route path="/setup" element={<Setup />} />
                        <Route path="/blog" element={<Blog />} />
                        <Route path="/policy" element={<Policy />} />
                        <Route
                            path="/policy/:policyName"
                            element={<Policy />}
                        />
                        <Route path="*" element={<NotFound />} />
                        <Route element={<PrivateRoutes />}>
                            <Route path="/app" element={<OakApp />} />
                            <Route path="/account" element={<Account />} />
                        </Route>
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}
